export const randomInt = (lower, upper) => {
    return lower + Math.floor(Math.random() * (upper - lower + 1));
}

export const randomChoice = (items) => {
    let i = randomInt(0, items.length - 1);
    return items[i]
}

export const fakeAccountNum = () => {
    let acct = '';

    for (let i=0; i < 8; i++) {
        acct += Math.floor(Math.random() * 10)
    }
    return acct
}

export const accountTypes = ["CHK", "SAV", "MM", "CD", "CARD", "LOC", "LOAN"]
export const accountTypeLabels = {
    "CHK": 'Checking',
    "SAV": 'Savings',
    "MM": 'Money Market',
    "CD": 'CD',
    "CARD": 'Credit Card',
    "LOC": 'Line of Credit',
    "LOAN": 'Loan'
}

const randomAccountType = () => {
    return randomChoice(accountTypes)
}

const intId = () => {
    let x = crypto.getRandomValues(new Uint32Array(1))
    return x[0]
}

export const fakeAccounts = (n, mustBeSavings=false) => {
    let accts = []
    let type_opts = ['CHK', 'CHK', 'SAV']

    for (let i=0; i < 3; i++) {
        let a = fakeAccountNum()
        // let t = i == 0 ? (!mustBeSavings ? 'CHK' : 'SAV') : randomAccountType()
        let t = type_opts[i]
        let amt

        if (t == 'CHK') {
            amt = 2500
        }
        else if (t == 'SAV') {
            amt = 3500
        }
        else {
            amt = Number(Math.random() * randomInt(2500, 3500)).toFixed(2)
        }

        accts.push({
            "accountId": intId(),
            "formattedAccountNumber": a,
            "accountType": t,
            "nickname": "",
            "balances": [
                {
                    "type": "current",
                    "amount": amt
                }
            ],
            "accountNumber": a,
            "alternateAccountNumber": "",
            "coreComponents": {
            },
            "micr": "",
            "openDate": "2019-11-27",
            "privileges": {},
            "isAsset": false,
            "isLiability": false,
            "branchNumber": "",
            "details": [],
            "statementDeliveryOption": "",
            "statementDeliveryEmail": [],
            "statementDeliveryEnrollmentTime": "",
            "ownerName": "",
            "ownerAddress": {}
        })
    }

    return accts
}

export const propertyTaxes = {
    'Hawaii': 0.27,
    'Alabama': 0.42,
    'Louisiana': 0.52,
    'Colorado': 0.55,
    'District of Columbia': 0.55,
    'Delaware': 0.56,
    'South Carolina': 0.57,
    'West Virginia': 0.59,
    'Wyoming': 0.61,
    'Arkansas': 0.63,
    'Utah': 0.66,
    'Nevada': 0.69,
    'Arizona': 0.72,
    'Tennessee': 0.74,
    'Idaho': 0.75,
    'California': 0.77,
    'New Mexico': 0.78,
    'Virginia': 0.80,
    'Mississippi': 0.80,
    'Montana': 0.84,
    'North Carolina': 0.86,
    'Kentucky': 0.86,
    'Indiana': 0.87,
    'Oklahoma': 0.90,
    'Georgia': 0.91,
    'Florida': 0.98,
    'Missouri': 0.99,
    'North Dakota': 1.01,
    'Washington': 1.03,
    'Oregon': 1.04,
    'Maryland': 1.10,
    'Minnesota': 1.15,
    'Alaska': 1.19,
    'Massachusetts': 1.22,
    'South Dakota': 1.32,
    'Maine': 1.35,
    'Kansas': 1.40,
    'Iowa': 1.53,
    'Ohio': 1.57,
    'Pennsylvania': 1.58,
    'Michigan': 1.64,
    'Rhode Island': 1.66,
    'New York': 1.68,
    'Nebraska': 1.80,
    'Texas': 1.83,
    'Vermont': 1.83,
    'Wisconsin': 1.94,
    'Connecticut': 2.07,
    'New Hampshire': 2.20,
    'Illinois': 2.31,
    'New Jersey': 2.44,
}

export const states = Object.keys(propertyTaxes)
